// Generated by apps/web/scripts/build-ingested-assets.mjs (vehicles-post) from public/world/models/vehicles-ccby/*.meta.json. Do not edit.
import type { VehicleDims } from "./dims.js";

export const VEHICLE_DIMS: Readonly<Record<string, VehicleDims>> = {
  bicycle_classic: {
    class: "bike",
    length: 1.8,
    width: 0.5,
    height: 1.14,
    bounds: {
      min: [-0.25, 0, -0.9],
      max: [0.25, 1.14, 0.9],
    },
    massKg: 14,
    wheelRadius: 0.338,
    wheelbase: 1.12,
    track: 0,
    wheels: {
      wheel_f: {
        x: 0,
        y: 0.338,
        z: 0.56,
        r: 0.338,
        w: 0.127,
      },
      wheel_r: {
        x: 0,
        y: 0.338,
        z: -0.56,
        r: 0.338,
        w: 0.083,
      },
    },
    door: null,
    steering: null,
    seat: [0, 0.82, -0.168],
    lamps: {
      head: [
        [0.18, 0.479, 0.556],
        [-0.18, 0.479, 0.556],
      ],
      tail: [
        [0.18, 0.57, -0.49],
        [-0.18, 0.57, -0.49],
      ],
    },
  },
  bus_town: {
    class: "bus",
    length: 12,
    width: 2.92,
    height: 2.97,
    bounds: {
      min: [-1.46, 0, -6.43],
      max: [1.46, 2.97, 5.57],
    },
    massKg: 12000,
    wheelRadius: 0.532,
    wheelbase: 5.56,
    track: 1.928,
    wheels: {
      wheel_fr: {
        x: -1.008,
        y: 0.532,
        z: 2.78,
        r: 0.532,
        w: 0.345,
      },
      wheel_fl: {
        x: 1.032,
        y: 0.532,
        z: 2.78,
        r: 0.532,
        w: 0.345,
      },
      wheel_rr: {
        x: -0.897,
        y: 0.532,
        z: -2.78,
        r: 0.532,
        w: 0.625,
      },
      wheel_rl: {
        x: 0.918,
        y: 0.532,
        z: -2.78,
        r: 0.532,
        w: 0.631,
      },
    },
    door: {
      node: "door_fr",
      side: -1,
      hinge: [-1.38, 1.554, 5.275],
      length: 1.15,
      y0: 0.32,
      y1: 2.788,
      tris: 305,
      cut: true,
    },
    steering: {
      x: 0.877,
      y: 1.62,
      z: 3.53,
      r: 0.25,
    },
    seat: [0.877, 1.07, 2.91],
    lamps: {
      head: [
        [1.053, 0.85, 5.39],
        [-1.053, 0.85, 5.39],
      ],
      tail: [
        [1.053, 1, -6.425],
        [-1.053, 1, -6.425],
      ],
    },
  },
  city_compact: {
    class: "city",
    length: 4,
    width: 1.97,
    height: 1.62,
    bounds: {
      min: [-0.99, 0, -1.91],
      max: [0.99, 1.62, 2.09],
    },
    massKg: 1100,
    wheelRadius: 0.298,
    wheelbase: 2.558,
    track: 1.408,
    wheels: {
      wheel_fl: {
        x: 0.704,
        y: 0.298,
        z: 1.279,
        r: 0.298,
        w: 0.228,
      },
      wheel_rl: {
        x: 0.704,
        y: 0.298,
        z: -1.279,
        r: 0.298,
        w: 0.228,
      },
      wheel_rr: {
        x: -0.704,
        y: 0.298,
        z: -1.279,
        r: 0.298,
        w: 0.228,
      },
      wheel_fr: {
        x: -0.704,
        y: 0.298,
        z: 1.279,
        r: 0.298,
        w: 0.228,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.987, 0.88, 0.921],
      length: 1.02,
      y0: 0.215,
      y1: 1.545,
      tris: 360,
      cut: true,
    },
    steering: {
      x: 0.31,
      y: 0.969,
      z: 0.281,
      r: 0.18,
    },
    seat: [0.31, 0.539, -0.299],
    lamps: {
      head: [
        [0.568, 0.744, 1.786],
        [-0.568, 0.744, 1.786],
      ],
      tail: [
        [0.669, 0.875, -1.768],
        [-0.669, 0.875, -1.768],
      ],
    },
  },
  classic_e30: {
    class: "city",
    length: 4.33,
    width: 1.72,
    height: 1.36,
    bounds: {
      min: [-0.86, 0, -2.28],
      max: [0.86, 1.36, 2.05],
    },
    massKg: 1100,
    wheelRadius: 0.301,
    wheelbase: 2.576,
    track: 1.442,
    wheels: {
      wheel_fl: {
        x: 0.706,
        y: 0.301,
        z: 1.288,
        r: 0.301,
        w: 0.231,
      },
      wheel_fr: {
        x: -0.736,
        y: 0.301,
        z: 1.288,
        r: 0.301,
        w: 0.231,
      },
      wheel_rl: {
        x: 0.706,
        y: 0.301,
        z: -1.288,
        r: 0.301,
        w: 0.231,
      },
      wheel_rr: {
        x: -0.736,
        y: 0.301,
        z: -1.288,
        r: 0.301,
        w: 0.231,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.859, 0.754, 0.927],
      length: 1.12,
      y0: 0.217,
      y1: 1.292,
      tris: 181,
      cut: true,
    },
    steering: {
      x: 0.317,
      y: 0.815,
      z: 0.283,
      r: 0.18,
    },
    seat: [0.317, 0.385, -0.297],
    lamps: {
      head: [
        [0.618, 0.571, 1.99],
        [-0.618, 0.571, 1.99],
      ],
      tail: [
        [0.618, 0.679, -2.176],
        [-0.618, 0.679, -2.176],
      ],
    },
  },
  cop_fairheaven80: {
    class: "sedan",
    length: 5,
    width: 1.81,
    height: 1.55,
    bounds: {
      min: [-0.9, 0, -2.57],
      max: [0.9, 1.55, 2.43],
    },
    massKg: 1750,
    wheelRadius: 0.299,
    wheelbase: 2.612,
    track: 1.454,
    wheels: {
      wheel_fl: {
        x: 0.726,
        y: 0.3,
        z: 1.306,
        r: 0.299,
        w: 0.234,
      },
      wheel_rl: {
        x: 0.726,
        y: 0.3,
        z: -1.306,
        r: 0.299,
        w: 0.234,
      },
      wheel_fr: {
        x: -0.728,
        y: 0.299,
        z: 1.306,
        r: 0.299,
        w: 0.234,
      },
      wheel_rr: {
        x: -0.728,
        y: 0.299,
        z: -1.306,
        r: 0.299,
        w: 0.234,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.903, 0.744, 0.947],
      length: 1.1,
      y0: 0.215,
      y1: 1.273,
      tris: 608,
      cut: true,
    },
    steering: {
      x: 0.335,
      y: 0.771,
      z: 0.215,
      r: 0.164,
    },
    seat: [0.335, 0.341, -0.365],
    lamps: {
      head: [
        [0.577, 0.671, 2.128],
        [-0.577, 0.67, 2.128],
      ],
      tail: [
        [0.641, 0.644, -2.441],
        [-0.641, 0.643, -2.441],
      ],
    },
  },
  coupe_generic: {
    class: "sport",
    length: 4.4,
    width: 1.96,
    height: 1.33,
    bounds: {
      min: [-0.98, 0, -2.18],
      max: [0.98, 1.33, 2.22],
    },
    massKg: 1350,
    wheelRadius: 0.312,
    wheelbase: 2.504,
    track: 1.376,
    wheels: {
      wheel_rl: {
        x: 0.688,
        y: 0.312,
        z: -1.252,
        r: 0.312,
        w: 0.289,
      },
      wheel_fr: {
        x: -0.688,
        y: 0.312,
        z: 1.252,
        r: 0.312,
        w: 0.289,
      },
      wheel_rr: {
        x: -0.688,
        y: 0.312,
        z: -1.252,
        r: 0.312,
        w: 0.289,
      },
      wheel_fl: {
        x: 0.688,
        y: 0.312,
        z: 1.252,
        r: 0.312,
        w: 0.289,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.978, 0.75, 0.88],
      length: 1.25,
      y0: 0.225,
      y1: 1.276,
      tris: 195,
      cut: true,
    },
    steering: {
      x: 0.303,
      y: 0.796,
      z: 0.275,
      r: 0.18,
    },
    seat: [0.303, 0.366, -0.305],
    lamps: {
      head: [
        [0.515, 0.636, 2.023],
        [-0.515, 0.636, 2.023],
      ],
      tail: [
        [0.489, 0.72, -2.054],
        [-0.489, 0.72, -2.054],
      ],
    },
  },
  scooter_electric: {
    class: "bike",
    length: 1.2,
    width: 0.55,
    height: 1.26,
    bounds: {
      min: [-0.28, 0, -0.6],
      max: [0.28, 1.26, 0.6],
    },
    massKg: 18,
    wheelRadius: 0.121,
    wheelbase: 0.942,
    track: 0,
    wheels: {
      wheel_r: {
        x: 0.001,
        y: 0.132,
        z: -0.471,
        r: 0.131,
        w: 0.057,
      },
      wheel_f: {
        x: 0.001,
        y: 0.11,
        z: 0.471,
        r: 0.11,
        w: 0.069,
      },
    },
    door: null,
    steering: null,
    seat: [0, 0.905, -0.141],
    lamps: {
      head: [
        [0.199, 0.528, -0.297],
        [-0.199, 0.528, -0.297],
      ],
      tail: [
        [0.199, 0.628, -0.396],
        [-0.199, 0.628, -0.396],
      ],
    },
  },
  sedan_generic: {
    class: "sedan",
    length: 4.7,
    width: 2.09,
    height: 1.45,
    bounds: {
      min: [-1.05, 0, -2.36],
      max: [1.05, 1.45, 2.34],
    },
    massKg: 1450,
    wheelRadius: 0.328,
    wheelbase: 2.82,
    track: 1.504,
    wheels: {
      wheel_fl: {
        x: 0.756,
        y: 0.33,
        z: 1.401,
        r: 0.328,
        w: 0.246,
      },
      wheel_rl: {
        x: 0.749,
        y: 0.328,
        z: -1.411,
        r: 0.328,
        w: 0.246,
      },
      wheel_fr: {
        x: -0.75,
        y: 0.328,
        z: 1.418,
        r: 0.328,
        w: 0.246,
      },
      wheel_rr: {
        x: -0.753,
        y: 0.328,
        z: -1.409,
        r: 0.328,
        w: 0.246,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [1.047, 0.816, 1.021],
      length: 1.08,
      y0: 0.236,
      y1: 1.395,
      tris: 244,
      cut: true,
    },
    steering: {
      x: 0.331,
      y: 0.868,
      z: 0.31,
      r: 0.18,
    },
    seat: [0.331, 0.438, -0.27],
    lamps: {
      head: [
        [0.598, 0.595, 2.191],
        [-0.595, 0.595, 2.192],
      ],
      tail: [
        [0.58, 0.72, -2.3],
        [-0.586, 0.72, -2.299],
      ],
    },
  },
  sport_concept: {
    class: "sport",
    length: 4.6,
    width: 2.68,
    height: 1.21,
    bounds: {
      min: [-1.34, 0, -2.14],
      max: [1.34, 1.21, 2.46],
    },
    massKg: 1400,
    wheelRadius: 0.319,
    wheelbase: 2.956,
    track: 2.076,
    wheels: {
      wheel_fl: {
        x: 1.032,
        y: 0.405,
        z: 1.479,
        r: 0.319,
        w: 0.57,
      },
      wheel_fr: {
        x: -1.035,
        y: 0.406,
        z: 1.477,
        r: 0.318,
        w: 0.568,
      },
      wheel_rl: {
        x: 1.043,
        y: 0.406,
        z: -1.478,
        r: 0.32,
        w: 0.294,
      },
      wheel_rr: {
        x: -1.042,
        y: 0.405,
        z: -1.478,
        r: 0.32,
        w: 0.294,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [1.234, 0.671, 0.959],
      length: 1.763,
      y0: 0.164,
      y1: 1.177,
      cut: false,
    },
    steering: {
      x: 0.001,
      y: 0.688,
      z: 0.895,
      r: 0.181,
    },
    seat: [0.001, 0.32, 0.315],
    lamps: {
      head: [
        [0.668, 0.694, 2.304],
        [-0.668, 0.694, 2.304],
      ],
      tail: [
        [0.967, 0.606, -2.082],
        [-0.967, 0.606, -2.082],
      ],
    },
  },
  sport_phoenix455: {
    class: "sport",
    length: 4.6,
    width: 1.96,
    height: 1.25,
    bounds: {
      min: [-0.98, 0, -2.46],
      max: [0.98, 1.25, 2.14],
    },
    massKg: 1500,
    wheelRadius: 0.303,
    wheelbase: 2.578,
    track: 1.61,
    wheels: {
      wheel_fl: {
        x: 0.806,
        y: 0.306,
        z: 1.289,
        r: 0.303,
        w: 0.274,
      },
      wheel_rl: {
        x: 0.806,
        y: 0.306,
        z: -1.289,
        r: 0.303,
        w: 0.274,
      },
      wheel_fr: {
        x: -0.804,
        y: 0.303,
        z: 1.289,
        r: 0.303,
        w: 0.274,
      },
      wheel_rr: {
        x: -0.804,
        y: 0.303,
        z: -1.289,
        r: 0.303,
        w: 0.274,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.982, 0.707, 0.926],
      length: 1.2,
      y0: 0.218,
      y1: 1.196,
      tris: 636,
      cut: true,
    },
    steering: {
      x: 0.349,
      y: 0.741,
      z: -0.067,
      r: 0.151,
    },
    seat: [0.349, 0.32, -0.647],
    lamps: {
      head: [
        [0.728, 0.482, 2.028],
        [-0.727, 0.48, 2.028],
      ],
      tail: [
        [0.565, 0.593, -2.343],
        [-0.564, 0.591, -2.343],
      ],
    },
  },
  sport_saba95: {
    class: "sport",
    length: 4.5,
    width: 2.17,
    height: 1.32,
    bounds: {
      min: [-1.09, 0, -2.15],
      max: [1.09, 1.32, 2.35],
    },
    massKg: 1300,
    wheelRadius: 0.346,
    wheelbase: 2.74,
    track: 1.569,
    wheels: {
      wheel_fl: {
        x: 0.771,
        y: 0.329,
        z: 1.37,
        r: 0.325,
        w: 0.27,
      },
      wheel_rl: {
        x: 0.797,
        y: 0.366,
        z: -1.37,
        r: 0.366,
        w: 0.369,
      },
      wheel_fr: {
        x: -0.771,
        y: 0.329,
        z: 1.37,
        r: 0.325,
        w: 0.27,
      },
      wheel_rr: {
        x: -0.798,
        y: 0.366,
        z: -1.37,
        r: 0.366,
        w: 0.369,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [1.086, 0.756, 0.964],
      length: 1.2,
      y0: 0.249,
      y1: 1.263,
      tris: 570,
      cut: true,
    },
    steering: {
      x: 0.373,
      y: 0.78,
      z: 0.752,
      r: 0.178,
    },
    seat: [0.373, 0.35, 0.172],
    lamps: {
      head: [
        [0.634, 0.646, 1.926],
        [-0.634, 0.646, 1.926],
      ],
      tail: [
        [0.685, 0.934, -1.954],
        [-0.685, 0.934, -1.954],
      ],
    },
  },
  suv_generic: {
    class: "suv",
    length: 4.9,
    width: 2.2,
    height: 1.84,
    bounds: {
      min: [-1.1, 0, -2.52],
      max: [1.1, 1.84, 2.38],
    },
    massKg: 1950,
    wheelRadius: 0.399,
    wheelbase: 2.901,
    track: 1.55,
    wheels: {
      wheel_fl: {
        x: 0.774,
        y: 0.399,
        z: 1.451,
        r: 0.399,
        w: 0.337,
      },
      wheel_rl: {
        x: 0.776,
        y: 0.399,
        z: -1.45,
        r: 0.399,
        w: 0.337,
      },
      wheel_fr: {
        x: -0.776,
        y: 0.399,
        z: 1.45,
        r: 0.399,
        w: 0.337,
      },
      wheel_rr: {
        x: -0.774,
        y: 0.399,
        z: -1.451,
        r: 0.399,
        w: 0.337,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [1.099, 1.028, 0.991],
      length: 1.12,
      y0: 0.287,
      y1: 1.768,
      tris: 351,
      cut: true,
    },
    steering: {
      x: 0.341,
      y: 1.105,
      z: 0.319,
      r: 0.18,
    },
    seat: [0.341, 0.675, -0.261],
    lamps: {
      head: [
        [0.704, 0.753, 2.237],
        [-0.706, 0.753, 2.237],
      ],
      tail: [
        [0.777, 0.996, -2.39],
        [-0.774, 0.996, -2.391],
      ],
    },
  },
  suv_lightbody85: {
    class: "suv",
    length: 4.9,
    width: 2.13,
    height: 1.91,
    bounds: {
      min: [-1.07, 0, -2.59],
      max: [1.07, 1.91, 2.31],
    },
    massKg: 2100,
    wheelRadius: 0.347,
    wheelbase: 2.886,
    track: 1.552,
    wheels: {
      wheel_fl: {
        x: 0.778,
        y: 0.35,
        z: 1.443,
        r: 0.347,
        w: 0.319,
      },
      wheel_rl: {
        x: 0.778,
        y: 0.35,
        z: -1.443,
        r: 0.347,
        w: 0.319,
      },
      wheel_fr: {
        x: -0.774,
        y: 0.347,
        z: 1.443,
        r: 0.347,
        w: 0.319,
      },
      wheel_rr: {
        x: -0.774,
        y: 0.347,
        z: -1.443,
        r: 0.347,
        w: 0.319,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [1.065, 0.936, 1.036],
      length: 1.15,
      y0: 0.25,
      y1: 1.622,
      tris: 869,
      cut: true,
    },
    steering: {
      x: 0.377,
      y: 1.133,
      z: 0.429,
      r: 0.161,
    },
    seat: [0.377, 0.703, -0.151],
    lamps: {
      head: [
        [0.592, 0.858, 2.129],
        [-0.59, 0.855, 2.129],
      ],
      tail: [
        [0.745, 0.96, -2.455],
        [-0.744, 0.957, -2.455],
      ],
    },
  },
  taxi_canyon75: {
    class: "sedan",
    length: 4.9,
    width: 1.97,
    height: 1.69,
    bounds: {
      min: [-0.98, 0, -2.62],
      max: [0.98, 1.69, 2.28],
    },
    massKg: 1650,
    wheelRadius: 0.333,
    wheelbase: 2.95,
    track: 1.486,
    wheels: {
      wheel_fl: {
        x: 0.745,
        y: 0.335,
        z: 1.475,
        r: 0.333,
        w: 0.244,
      },
      wheel_rl: {
        x: 0.745,
        y: 0.335,
        z: -1.475,
        r: 0.333,
        w: 0.244,
      },
      wheel_fr: {
        x: -0.741,
        y: 0.333,
        z: 1.475,
        r: 0.333,
        w: 0.244,
      },
      wheel_rr: {
        x: -0.741,
        y: 0.333,
        z: -1.475,
        r: 0.333,
        w: 0.244,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.984, 0.876, 1.082],
      length: 1.08,
      y0: 0.24,
      y1: 1.511,
      tris: 393,
      cut: true,
    },
    steering: {
      x: 0.323,
      y: 0.987,
      z: 0.428,
      r: 0.154,
    },
    seat: [0.323, 0.557, -0.152],
    lamps: {
      head: [
        [0.668, 0.928, 2.192],
        [-0.667, 0.925, 2.192],
      ],
      tail: [
        [0.767, 0.845, -2.511],
        [-0.766, 0.843, -2.511],
      ],
    },
  },
  van_minivan: {
    class: "van",
    length: 4.8,
    width: 1.95,
    height: 1.84,
    bounds: {
      min: [-0.97, 0, -2.47],
      max: [0.97, 1.84, 2.33],
    },
    massKg: 1800,
    wheelRadius: 0.331,
    wheelbase: 2.958,
    track: 1.476,
    wheels: {
      wheel_fl: {
        x: 0.738,
        y: 0.331,
        z: 1.479,
        r: 0.331,
        w: 0.292,
      },
      wheel_rl: {
        x: 0.738,
        y: 0.331,
        z: -1.479,
        r: 0.331,
        w: 0.292,
      },
      wheel_fr: {
        x: -0.738,
        y: 0.331,
        z: 1.479,
        r: 0.331,
        w: 0.292,
      },
      wheel_rr: {
        x: -0.738,
        y: 0.331,
        z: -1.479,
        r: 0.331,
        w: 0.292,
      },
    },
    door: {
      node: "door_fl",
      side: 1,
      hinge: [0.973, 1.012, 1.088],
      length: 1.02,
      y0: 0.238,
      y1: 1.786,
      tris: 438,
      cut: true,
    },
    steering: {
      x: 0.325,
      y: 1.101,
      z: 0.325,
      r: 0.18,
    },
    seat: [0.325, 0.671, -0.255],
    lamps: {
      head: [
        [0.675, 0.592, 2.225],
        [-0.675, 0.592, 2.225],
      ],
      tail: [
        [0.73, 0.936, -2.318],
        [-0.73, 0.936, -2.318],
      ],
    },
  },
};
